"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resize_to_fit = void 0;
/* eslint-disable max-len */

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var resize_to_fit = function resize_to_fit(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var classes = (0, classnames_1["default"])('helix-icon', 'resize-to-fit-outlined', className);
  return react_1["default"].createElement("svg", Object.assign({
    className: classes,
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-hidden": 'true'
  }, rest), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M2.53033 2.46967C2.82322 2.17678 3.2981 2.17678 3.59099 2.46967L6.75 5.62868V4C6.75 3.58579 7.08579 3.25 7.5 3.25C7.91421 3.25 8.25 3.58579 8.25 4V7.5C8.25 7.91421 7.91421 8.25 7.5 8.25H4C3.58579 8.25 3.25 7.91421 3.25 7.5C3.25 7.08579 3.58579 6.75 4 6.75H5.75L2.53033 3.53033C2.23744 3.23744 2.23744 2.76256 2.53033 2.46967ZM17.5303 2.53033C17.8232 2.82322 17.8232 3.2981 17.5303 3.59099L14.3713 6.75H16C16.4142 6.75 16.75 7.08579 16.75 7.5C16.75 7.91421 16.4142 8.25 16 8.25H12.5C12.0858 8.25 11.75 7.91421 11.75 7.5V4C11.75 3.58579 12.0858 3.25 12.5 3.25C12.9142 3.25 13.25 3.58579 13.25 4V5.75L16.4697 2.53033C16.7626 2.23744 17.2374 2.23744 17.5303 2.53033ZM3.25 12.5C3.25 12.0858 3.58579 11.75 4 11.75H7.5C7.91421 11.75 8.25 12.0858 8.25 12.5V16C8.25 16.4142 7.91421 16.75 7.5 16.75C7.08579 16.75 6.75 16.4142 6.75 16V14.25L3.53033 17.4697C3.23744 17.7626 2.76256 17.7626 2.46967 17.4697C2.17678 17.1768 2.17678 16.7019 2.46967 16.409L5.62868 13.25H4C3.58579 13.25 3.25 12.9142 3.25 12.5ZM11.75 12.5C11.75 12.0858 12.0858 11.75 12.5 11.75H16C16.4142 11.75 16.75 12.0858 16.75 12.5C16.75 12.9142 16.4142 13.25 16 13.25H14.25L17.4697 16.4697C17.7626 16.7626 17.7626 17.2374 17.4697 17.5303C17.1768 17.8232 16.7019 17.8232 16.409 17.5303L13.25 14.3713V16C13.25 16.4142 12.9142 16.75 12.5 16.75C12.0858 16.75 11.75 16.4142 11.75 16V12.5Z',
    fill: '#4B5563'
  }));
};

exports.resize_to_fit = resize_to_fit;